import {PersonIcon} from '@primer/octicons-react'
import {Link, Text} from '@primer/react'
import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {LABELS} from '../constants'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {UnassignedEvent$key} from './__generated__/UnassignedEvent.graphql'
import {TimelineRow} from './row/TimelineRow'

type UnassignedEventProps = {
  queryRef: UnassignedEvent$key
  issueUrl: string
  highlightedEventId?: string
  refAttribute?: React.MutableRefObject<HTMLDivElement | null>
}

export function UnassignedEvent({
  queryRef,
  issueUrl,
  highlightedEventId,
  refAttribute,
}: UnassignedEventProps): JSX.Element {
  const {actor, createdAt, assignee, databaseId} = useFragment(
    graphql`
      fragment UnassignedEvent on UnassignedEvent {
        databaseId
        createdAt
        actor {
          login
          ...EventActor
        }
        assignee {
          ... on User {
            login
          }
          ... on Mannequin {
            login
          }
          ... on Organization {
            login
          }
          ... on Bot {
            login
          }
        }
      }
    `,
    queryRef,
  )
  const assigneeNode: JSX.Element =
    actor?.login === assignee?.login ? (
      <Text>{LABELS.timeline.removedTheirAssignment} </Text>
    ) : (
      <>
        {`${LABELS.timeline.unassigned} `}
        <Link href={`/${assignee?.login}`} sx={{color: 'fg.default', mr: 1}} muted>
          {assignee?.login}
        </Link>
      </>
    )

  const highlighted = String(databaseId) === highlightedEventId

  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      leadingIcon={PersonIcon}
    >
      <TimelineRow.Main>{assigneeNode}</TimelineRow.Main>
    </TimelineRow>
  )
}

try{ UnassignedEvent.displayName ||= 'UnassignedEvent' } catch {}